<template>
  <div>
    <!--  -->
    <B1 />

    <B2 />

    <Customer title="更多客户" entitle="More customers" />
  </div>
</template>

<script>
import B1 from "./components/b1.vue";
import B2 from "./components/b2.vue";
import Customer from "../layout/components/customer.vue";

export default {
  components: {
    B1,
    B2,
    Customer,
  },
};
</script>

<style>
</style>